'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTimestamp = exports.getText = exports.getStatus = exports.getSender = exports.getRichText = exports.getId = exports.getClientType = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _keyPaths = require('../constants/keyPaths');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getClientType = exports.getClientType = (0, _getIn2.default)(_keyPaths.CLIENT_TYPE);
var getId = exports.getId = (0, _getIn2.default)(_keyPaths.ID);
var getRichText = exports.getRichText = (0, _getIn2.default)(_keyPaths.RICH_TEXT);
var getSender = exports.getSender = (0, _getIn2.default)(_keyPaths.SENDER);
var getStatus = exports.getStatus = (0, _getIn2.default)(_keyPaths.STATUS);
var getText = exports.getText = (0, _getIn2.default)(_keyPaths.TEXT);
var getTimestamp = exports.getTimestamp = (0, _getIn2.default)(_keyPaths.TIMESTAMP);